<template>
    <v-container>
        <v-card class="pt-4 pl-2 pr-2 pb-2">
            <v-row class="pl-3 pr-3">
                <v-col>
                    <h2>transactions </h2>
                </v-col>
                <v-col>

                </v-col>
            </v-row>

            <v-simple-table>
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">
                                Name
                            </th>
                            <th class="text-left">
                                transaction ID
                            </th>
                            <th class="text-left">
                                Amount (₦)
                            </th>
                            <th class="text-left">
                                Amount ($)
                            </th>
                            <th class="text-left">
                                Date
                            </th>
                            <th class="text-left">
                                transaction Type
                            </th>
                            <th class="text-left">
                                Status
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in transactions" :key="item.id">
                            <td>{{ item.firstname + ' ' + item.lastname }}</td>
                            <td>{{ item.reference }}</td>

                            <td>{{ formatMoney(item.naira_amount) }}</td>
                            <td>{{ formatMoney(item.dollar_amount) }}</td>
                            <td>{{ item.created | moment("dddd, MMMM Do YYYY") }}</td>
                            <td>{{ item.slug }}</td>
                            <td>
                                
                                <v-chip v-if="item.status === 'approved'" class="ma-2" color="success">
                                    {{ item.status }}
                                </v-chip>
                                <v-chip v-else class="ma-2" color="primary">
                                    {{ item.status }}
                                </v-chip>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <v-row>
                <v-col>
                    <v-pagination
      v-model="page"
      :length="count"
      @input="updateTransactions"
      rounded="circle"
    ></v-pagination>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>

// =========== IMPORT SERVICE =========
import { UsersService } from "@/services";
import { formatMoney } from '@/utils/moneyFormatter';

export default {
    data() {
        return {
            transactions: [],
            loading: true,
            count: 0,
            page: 1,
        }
    },
    async mounted() {
        this.getToptransactions();
        this.getTransCount();
    },
    methods: {
        async getToptransactions() {
            try {
                this.transactions = [];
                this.loading = true;
                let data = await UsersService.toptransactions();
                this.loading = false;
                this.transactions = data;
            } catch (error) {
                this.loading = false;
            }
        },

        async getTransCount() {
            try {
                let data = await UsersService.getCountTransactions();
                this.count = Math.ceil( Number(data[0].record_count) / 10);
            
            } catch (error) {
                console.log(error);
            }
        },
        async updateTransactions(){
            try {
                this.loading = true;
                let data = await UsersService.transactionPage(this.page - 1);
                console.log('transcations update', data);
                this.loading = false;
                this.transactions = [];
                this.transactions = data;
            } catch (error) {
                console.log(error);
            }
        },
        formatMoney(amount) {
            return formatMoney(amount, false);
        },
    }

}
</script>